export enum HitchType {
    NONE = 1,
    BIKE_RACK = 2,
    TRAILER = 3,
}
